export enum TileTypes {
  Table = 0,
  Clock,
  Weather,
  List
}
